import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-12 pb-4 px-4 bg-white text-center" data-id="element-140">
      <div className="max-w-4xl mx-auto" data-id="element-141">
        <p className="md:text-xs text-gray-400 tracking-wider mb-4 text-[12px] font-[600] font-[Figtree,_sans-serif]" data-id="element-142">
          "Recurso educativo digital para docentes de primaria"
        </p>

        <h1 className="text-3xl md:text-5xl font-black mb-1 leading-tight tracking-tight" data-id="element-143">
          <span className="px-2 text-[#F9327E] bg-[#FFFFFF] text-[24px]" data-id="element-144">
            PACK EFEMÉRIDES LISTAS
          </span>
        </h1>

        <h2 className="md:text-2xl font-extrabold mb-3 text-gray-800 text-[16px]" data-id="element-145">
          El pack docente que te resuelve todas las efemérides del año en
          minutos
        </h2>

        <a href="#compra" className="block max-w-[600px] mx-auto mb-3 cursor-pointer hover:opacity-95 transition-opacity" data-id="element-146">
          <img src="https://cdn.magicpatterns.com/uploads/ms72LmvpeYej2RraJgP5mv/2_IMAGEN.png" alt="Pack Efemérides Listas" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl" data-id="element-147" />
        </a>

        <div className="text-lg md:text-xl mb-4 text-gray-700 space-y-2 max-w-3xl mx-auto font-medium" data-id="element-148">
          <p className="text-[14px]" data-id="element-149">
            No pierdas tiempo buscando efemérides, actividades y discursos. Con
            este pack vas a tener todo organizado, listo para usar y preparado
            para cada fecha del calendario escolar.
          </p>
        </div>

        <div className="bg-blue-50 rounded-2xl p-5 max-w-md mx-auto border border-blue-100" data-id="element-150">
          <p className="text-lg font-black text-gray-900 mb-3" data-id="element-151">
            👉 Acceso inmediato y organizado
          </p>
          <div className="space-y-2 text-left" data-id="element-152">
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-153">
              <span className="text-green-600 mr-2 text-lg" data-id="element-154">✔️</span> Comprás
              ahora
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-155">
              <span className="text-green-600 mr-2 text-lg" data-id="element-156">✔️</span> Recibís un
              email automático
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-157">
              <span className="text-green-600 mr-2 text-lg" data-id="element-158">✔️</span> Accedés a
              todo el contenido organizado por mes
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-159">
              <span className="text-green-600 mr-2 text-lg" data-id="element-160">✔️</span> Podés
              descargar o usar directamente
            </p>
          </div>
        </div>
      </div>
    </section>;
}